<template>
	<div
		:class="[
			'section-header',
			...variantClassList,
			hasBorder && 'section-header__border'
		]"
	>
		<div class="section-header__container">
			<div class="section-header__icon-text-container">
				<span class="section-header__icon" v-if="hasIcon">
					<i :class="['icon', iconClassName]"></i>
				</span>
				<span class="section-header__text">
					<slot>
						{{ sectionText }}
					</slot>
				</span>
			</div>

			<span v-if="hasButton" class="section-header__button">
				<slot name="btnslot"></slot>
			</span>
		</div>

		<Divider
			v-if="variant === 'textDivider'"
			class="section-header__divider"
		/>
	</div>
</template>

<script>
import variantClasses from './variant-classes/section-header-variant-classes';
import componentVariantMixin from '@/mixins/component-variant-mixin';
import BaseComponentMixin from '@/mixins/base-component-mixin.js';
import Divider from '@/components/visual/divider/divider.vue';

export default {
	name: 'SectionHeader',
	components: {
		Divider
	},
	props: {
		sectionText: {
			type: String,
			default: null
		},
		hasIcon: {
			type: Boolean,
			default: null
		},
		iconClassName: {
			type: String,
			default: ''
		},
		hasBorder: {
			type: Boolean,
			default: null
		},
		hasButton: {
			type: Boolean,
			default: null
		},
		hasDivider: {
			type: Boolean,
			default: null
		}
	},
	mixins: [componentVariantMixin, BaseComponentMixin],
	created() {
		this.variantClasses = variantClasses;
	}
};
</script>

<style lang="scss" scoped>
.section-header {
	padding: $padding-sm;
	background-color: var(--bg-0);
	color: var(--bg-0-fg-4);
	width: 100%;

	&__container {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	&__icon-text-container {
		display: inline-flex;
		justify-content: center;
		align-items: center;
		gap: $gutter-md;
	}

	&__icon {
		display: inline-flex;
		justify-content: center;
		align-items: center;
		font-size: $section-header-icon-font-size;
	}

	&__text {
		@include heading(lg);
	}

	&__border {
		position: relative;

		&::after {
			content: '';
			@include transform-vertical-center;
			left: 0;
			transform: translateY(-50%);
			width: calc(100% + 1px);
			height: calc(100% + 1px);
			border: $section-header-border;
			z-index: $z-level1-1;
		}
	}
}

.section-header--bg-1 {
	background-color: var(--bg-1);
	color: var(--bg-1-fg-3);
}

.section-header--bg-2 {
	background-color: var(--bg-2);
	color: var(--bg-2-fg-3);
}

.section-header--txt-divider,
.section-header--txt {
	padding: 0;
	background: none;

	.section-header__text {
		@include heading('md');
	}

	// To prevent someone put "hasBorder" variable to true
	&.section-header__border {
		&::after {
			content: none;
		}
	}
}
.section-header--txt-divider {
	.section-header__divider {
		margin-top: $gutter-md;
	}
}
</style>
